import { MessageContainer } from "./MessageContainer";
import { GameVars } from "../../../GameVars";
import { GameConstants } from "../../../GameConstants";
import { PlayerAvatarContainer } from "./PlayerAvatarContainer";
import { PuckValuesContainer } from "./PuckValuesContainer";
import * as Carrom from "carrom-king-engine";

export class HUD extends Phaser.GameObjects.Container {

    public playerAvatarContainer: PlayerAvatarContainer;
    public adversaryAvatarContainer: PlayerAvatarContainer;

    public messageContainer: MessageContainer;

    private puckValuesContainer: PuckValuesContainer;

    constructor(scene: Phaser.Scene) {
        
        super(scene);

        this.x = GameConstants.GAME_WIDTH / 2;
        this.scaleY = GameVars.scaleY;

        this.playerAvatarContainer = new PlayerAvatarContainer(this.scene, true, this);
        this.add(this.playerAvatarContainer);

        this.adversaryAvatarContainer = new PlayerAvatarContainer(this.scene, false, this);
        this.add(this.adversaryAvatarContainer);

        if (GameVars.gameMode === Carrom.GameMode.FREESTYLE) {
            this.puckValuesContainer = new PuckValuesContainer(this.scene);
            this.scene.add.existing(this.puckValuesContainer);
        } else {
            this.puckValuesContainer = null;
        }

        this.messageContainer = new MessageContainer(this.scene);
        this.add(this.messageContainer);
    }

    public updateTimer(): void {

        if (GameVars.currentTurnPlayerId === GameVars.playerData.id) {
            this.playerAvatarContainer.updateTimer();
        } else {
            this.adversaryAvatarContainer.updateTimer();
        }
    }

    public onPuckActorArrived(color: string, isPlayer: boolean): void {

        if (GameVars.gameMode === Carrom.GameMode.PROFESSIONAL) {

            switch (color) {

                case Carrom.Color.RED:

                    if (isPlayer) {
                        this.playerAvatarContainer.onQueenPocketed();
                    } else {
                        this.adversaryAvatarContainer.onQueenPocketed();
                    } 
                   
                    break;
                
                case Carrom.Color.BLACK:

                    if (GameVars.reversedBoard) {
                        this.adversaryAvatarContainer.updatePocketedPucks();
                    } else {
                        this.playerAvatarContainer.updatePocketedPucks();
                    }
                   
                    break;

                case Carrom.Color.WHITE:
                    
                    if (GameVars.reversedBoard) {
                        this.playerAvatarContainer.updatePocketedPucks();
                    } else {
                        this.adversaryAvatarContainer.updatePocketedPucks();
                    }
                    break;
            
                default:
                    break;
            }
        } 
    }

    public onNewTurn(): void {

        if (GameVars.currentTurnPlayerId === GameVars.playerData.id) {
            this.playerAvatarContainer.activate();
            this.adversaryAvatarContainer.deactivate();
        } else {
            this.playerAvatarContainer.deactivate();
            this.adversaryAvatarContainer.activate();
        }

        if (GameVars.gameMode === Carrom.GameMode.PROFESSIONAL) {

            //
            
        } else {

            this.playerAvatarContainer.updateScore();
            this.adversaryAvatarContainer.updateScore();
        }

        this.messageContainer.showMessage(); 
    }

    public showDisconnectionMessage(): void {

        this.messageContainer.showDisconnectionMessage();
    }

    public hideDisconnectionMessage(): void {

        this.messageContainer.hideDisconnectionMessage();
    }

    public onQueenRestituted(): void {

        if (GameVars.gameMode === Carrom.GameMode.PROFESSIONAL) {

            this.adversaryAvatarContainer.onQueenRestituted();
            this.playerAvatarContainer.onQueenRestituted();
        }
    }

    public onDiskRestituted(color: string): void {

        if (GameVars.gameMode === Carrom.GameMode.PROFESSIONAL) {
            this.adversaryAvatarContainer.onDiskRestituted(color);
            this.playerAvatarContainer.onDiskRestituted(color);
        }
    }

    public onShot(): void {

        if (GameVars.currentTurnPlayerId === GameVars.playerData.id) {
            this.playerAvatarContainer.onShot();
        } else {
            this.adversaryAvatarContainer.onShot();
        }
    }

    public showEmoji(i: number, isPlayer: boolean): void {

        if (isPlayer) {
            this.playerAvatarContainer.showEmoji(i);
        } else {
            this.adversaryAvatarContainer.showEmoji(i);
        }
    }

    public onGameOver(): void {

        if (GameVars.gameMode === Carrom.GameMode.FREESTYLE) {
            this.playerAvatarContainer.updateScore();
            this.adversaryAvatarContainer.updateScore();
        }

        this.scene.add.tween({
            targets: this,
            alpha: 0,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 350,
            delay: 1500,
            onComplete: function(): void {
                this.visible = false;
            },
            onCompleteScope: this
        });

        if (this.puckValuesContainer) {

            this.scene.add.tween({
                targets: this.puckValuesContainer,
                alpha: 0,
                ease: Phaser.Math.Easing.Cubic.Out,
                duration: 350,
                onComplete: function(): void {
                    this.puckValuesContainer.visible = false;
                },
                onCompleteScope: this
            });
        }
    }
}
